import ApiService from "./api.service";

class AiGeneratorService extends ApiService {
    generateAiSessionProtocol(id, data) {
        return this.post(`AiGenerator/generate/protocol/session/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            responseType: "arraybuffer"
        });
    }
}

export default new AiGeneratorService();
